module.exports = __webpack_public_path__ + "static/media/about-2-bg-a.07b7b457.jpg";